<template>
  <div class="ad-shortcuts">
    <template v-if="!$store.state.teacherAccess">
      <button
        v-for="item in items"
        :key="item.route"
        type="button"
        class="ad-shortcut"
        :class="'ad-shortcut--' + item.tone"
        :title="item.text"
        @click="goTo(item.route)"
      >
        <v-icon size="18">
          {{ item.icon }}
        </v-icon>
        <span v-if="!isMobile">{{ item.text }}</span>
      </button>
    </template>
    <template v-else>
      <button
        type="button"
        class="ad-shortcut ad-shortcut--pink"
        :title="$t('turnover')"
        @click="turnover()"
      >
        <v-icon size="18">
          mdi-recycle-variant
        </v-icon>
        <span v-if="!isMobile">{{ $t('turnover') }}</span>
      </button>
      <button
        v-if="remain && remain !== 0"
        type="button"
        class="ad-shortcut ad-shortcut--blue ad-remain"
        @click="accountRemain"
      >
        <v-icon size="18">
          mdi-wallet-outline
        </v-icon>
        <span>
          {{ $t('remain') }}:
          <b class="ad-ltr">{{ $numberFormat(remain) }}</b>
          {{ (remain > 0 ? $t('debtor') : $t('creditor')) }}
        </span>
      </button>
    </template>
  </div>
</template>

<script>
  // Local copy of ./shortcut.vue (used by event.vue / home.vue) restyled for the academy dashboard.
  import General from '../../../../../Mixins/general'
  export default {
    name: 'DashboardShortcut',
    mixins: [General],
    data: () => ({
      remain: null,
      loading: false,
    }),
    computed: {
      items () {
        return [
          { route: 'academyStudentList', icon: 'mdi-account-group-outline', tone: 'green', text: this.$t('eventStudent', { name: this.$store.state.studentLabel }) },
          { route: 'recieve', icon: 'mdi-credit-card-multiple-outline', tone: 'blue', text: this.$t('cashReceive') },
          { route: 'academyEventList', icon: 'mdi-school-outline', tone: 'amber', text: this.$t('academyEventList') },
          { route: 'academySessionList', icon: 'mdi-calendar-text-outline', tone: 'blue', text: this.$t('academySessionList') },
          { route: 'cost', icon: 'mdi-account-cash-outline', tone: 'pink', text: this.$t('cost') },
        ]
      },
    },
    mounted () {
      if (this.$store.state.teacherAccess) {
        this.accountRemain()
      }
    },
    methods: {
      turnover () {
        this.$router.push({ name: 'turnover', params: { selfProp: 'active' } })
      },
      accountRemain () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'getdetail', {
          params: {
            select: 'accountRemain',
          },
        })
          .then(res => {
            res = res.data
            if (res.remain) {
              app.remain = res.remain.remain
            }
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
    },
  }
</script>

<style scoped lang="scss">
.ad-shortcuts {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.ad-shortcut {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 12px;
  border-radius: 6px;
  border: 1px solid rgba(15, 23, 42, .08);
  background: #fff;
  color: rgba(15, 23, 42, .8);
  font-size: .8rem;
  white-space: nowrap;
  transition: background .15s, border-color .15s;
  .v-icon { color: inherit; }
  &:hover { background: rgba(25, 118, 210, .06); border-color: rgba(25, 118, 210, .25); }
  &--green .v-icon { color: #2e7d32; }
  &--blue .v-icon { color: var(--v-primary-base, #1976d2); }
  &--amber .v-icon { color: #b26a00; }
  &--pink .v-icon { color: #c2185b; }
}
.ad-ltr { direction: ltr; unicode-bidi: isolate; }
.theme--dark .ad-shortcut {
  background: #1e1e1e;
  border-color: rgba(255, 255, 255, .1);
  color: rgba(255, 255, 255, .85);
  &:hover { background: rgba(100, 181, 246, .12); }
}
</style>
